























import Vue from "vue";
import { State, Action } from "vuex-class";
import Component from "vue-class-component";
import { FacebookState } from "../../../store/facebook";
const namespace = "facebook";

@Component
export default class Accounts extends Vue {
  @State("facebook") facebook: FacebookState;
  @Action("fetchAccounts", { namespace }) fetchAccounts: any;

  loading = false;

  fetch({ accountId, name }: { accountId: string; name?: string }) {
    this.loading = true;
    this.fetchAccounts({ accountId, name }).then(() => {
      this.loading = false;
    });
  }
  created() {
    this.fetch({ accountId: this.$route.params.accountId });
  }

  // computed variable based on user's email
}
